export default "__VITE_ASSET__CJaUWCFU__"